(function () {
    'use strict';

    var contactTypes = [
        {
            selector: '.reveal-phone',
            valueAttribute: 'data-full-phone',
            linkAttribute: 'data-tel-link',
            textSelector: '.phone-text',
            eventName: 'carbuy:phone-revealed'
        },
        {
            selector: '.reveal-email',
            valueAttribute: 'data-full-email',
            linkAttribute: 'data-mailto-link',
            textSelector: '.email-text',
            eventName: 'carbuy:email-revealed'
        }
    ];

    function completeReveal(button, contactType, fullValue, contactLink) {
        var contactText = button.querySelector(contactType.textSelector);
        if (!fullValue || !contactLink || !contactText) return false;

        contactText.textContent = fullValue;
        button.setAttribute('href', contactLink);
        button.setAttribute('data-revealed', 'true');
        button.classList.remove(contactType.selector.slice(1));

        button.dispatchEvent(new CustomEvent(contactType.eventName, {
            bubbles: true,
            detail: {
                carId: button.getAttribute('data-car-id') || null
            }
        }));

        return true;
    }

    function initContactReveal() {
        document.addEventListener('click', function (event) {
            if (!(event.target instanceof Element)) return;

            var contactType;
            var button;

            for (var index = 0; index < contactTypes.length; index += 1) {
                contactType = contactTypes[index];
                button = event.target.closest(contactType.selector);
                if (button) break;
            }

            if (!button) return;

            event.preventDefault();

            var endpoint = button.getAttribute('data-contact-endpoint') || '';
            var requestedType = button.getAttribute('data-contact-type') || '';
            if (endpoint && requestedType) {
                if (button.getAttribute('data-reveal-loading') === 'true') return;
                if (typeof window.csrfSafeAjaxPost !== 'function') return;

                button.setAttribute('data-reveal-loading', 'true');
                button.setAttribute('aria-busy', 'true');
                button.classList.add('is-loading');

                window.csrfSafeAjaxPost(
                    endpoint,
                    { contact_type: requestedType },
                    function (response) {
                        if (!response || response.success !== true) return;
                        completeReveal(
                            button,
                            contactType,
                            String(response.value || ''),
                            String(response.link || '')
                        );
                    },
                    function () {
                        button.classList.add('reveal-error');
                    },
                    function () {
                        button.removeAttribute('data-reveal-loading');
                        button.removeAttribute('aria-busy');
                        button.classList.remove('is-loading');
                    }
                );
                return;
            }

            var fullValue = button.getAttribute(contactType.valueAttribute) || '';
            var contactLink = button.getAttribute(contactType.linkAttribute) || '';
            completeReveal(button, contactType, fullValue, contactLink);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initContactReveal);
    } else {
        initContactReveal();
    }
})();
